<template>
  <div style="padding:14px 10px">
    <!-- 面包屑导航 -->
    <div class="cur_route">{{$route.name}}</div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home/index' }">Dashboard</el-breadcrumb-item>
      <el-breadcrumb-item>{{$route.name}}</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- Search筛选 -->
    <el-form :inline="true" :model="params" class="user-search">
      <el-form-item label="">
        <el-input size="small" v-model="params.name" placeholder="Agent name" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">Search</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">Add</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" element-loading-text="Loading..."
      style="width: 922px;">
      <el-table-column prop="name" label="Name" width="100">
      </el-table-column>
      <el-table-column prop="pwd" label="Password" width="120">
      </el-table-column>
      <el-table-column prop="business" label="Business" width="400">
      </el-table-column>
      <el-table-column prop="save_time" label="Save time" width="200">
        <template slot-scope="scope">
          <div>{{scope.row.save_time|timestampToTime}}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="Action" width="100">
        <template slot-scope="scope">
          <el-button size="mini" type="success" @click="handleEdit(scope.$index, scope.row)">Edit</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- Edit界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click='closeDialog("edit")'>
      <el-form label-width="120px" :model="editForm" ref="editForm" :rules="rules">
        <el-form-item label="Name" prop="name">
          <el-input size="small" v-model="editForm.name" auto-complete="off" placeholder="Agent name" clearable>
          </el-input>
        </el-form-item>
        <el-form-item label="Password" prop="pwd">
          <el-input size="small" v-model="editForm.pwd" auto-complete="off" placeholder="Agent password" clearable>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("edit")'>Cancel</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">Save
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {
    agentList,
    agentSave,
  } from '../../api/apiFun'
  import {
    timestampToTime
  } from '@/utils/util';
  import Pagination from '../../components/Pagination'
  export default {
    data() {
      return {
        loading: false, //是显示加载
        editFormVisible: false, //控制Edit页面显示与隐藏
        title: 'Add',
        editForm: {
          id: '',
          name: '',
          pwd: '',
        },
        // rules 表单验证
        rules: {
          name: [{
            required: true,
            message: 'Please enter the agent name',
            trigger: 'blur'
          }],
          pwd: [{
            required: true,
            message: 'Please enter the agent password',
            trigger: 'blur'
          }],
        },
        params: {
          page: 1,
          limit: 10,
          name: ''
        },
        listData: [],
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        }
      }
    },
    components: {
      Pagination
    },
    filters: {
      timestampToTime: function (timestamp) {
        return timestampToTime(timestamp)
      }
    },
    created() {
      this.getdata(this.params)
    },
    methods: {
      // 获取Agent list
      getdata(parameter) {
        this.loading = true
        agentList(parameter).then(res => {
          this.loading = false
          if (res.code == 400) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.listData = res.datas.list
            // 分页赋值
            this.pageparm.currentPage = this.params.page
            this.pageparm.pageSize = this.params.limit
            this.pageparm.total = res.datas.count
          }
        }).catch(err => {
          this.loading = false
          this.$message.error('Failed to get agent list, please try again later!')
        })
      },
      // 分页插件事件
      callFather(parm) {
        this.params.page = parm.currentPage
        this.params.limit = parm.pageSize
        this.getdata(this.params)
      },
      // Search事件
      search() {
        this.params.page = 1
        this.getdata(this.params)
      },
      //显示Edit界面
      handleEdit: function (index, row) {
        this.editFormVisible = true
        if (row != undefined && row != 'undefined') {
          this.title = 'Edit'
          this.editForm.id = row.id
          this.editForm.name = row.name
          this.editForm.pwd = row.pwd
        } else {
          this.title = 'Add'
          this.editForm.id = ''
          this.editForm.name = ''
          this.editForm.pwd = ''
        }
      },
      // Edit、增加页面Save方法
      submitForm(editData) {
        this.loading = true
        this.$refs[editData].validate(valid => {
          if (valid) {
            agentSave(this.editForm).then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.code == 200) {
                this.getdata(this.params)
                this.$message({
                  type: 'success',
                  message: 'Agent save succeeded!'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            }).catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('Saving failed, please try again later!')
            })
          } else {
            this.loading = false
            return false
          }
        })
      },
      // closeEdit、增加弹出框
      closeDialog(dialog) {
        if (dialog == 'edit') {
          this.editFormVisible = false
        } else if (dialog == 'perm') {}
      },
    }
  }

</script>

<style scoped>
  .user-search {
    margin-top: 20px;
  }

  .userRole {
    width: 100%;
  }

</style>



// WEBPACK FOOTER //
// src/views/operator/super_agent_list.vue